import * as API from 'patientOnboarding/api/legacy';
import { PayloadAction } from '@reduxjs/toolkit';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { setSessionData, setSessionDataError } from './actions';
import { SessionData } from './reducers';
import t from './types';

function* handleSessionToken(action: PayloadAction<string>): Generator<any> {
  try {
    const response = yield call(API.getPatientInfo, action.payload);
    yield put(setSessionData((response as { data: SessionData }).data));
  } catch (e) {
    yield put(setSessionDataError('You are not authorized'));
  }
}

function* sessionSaga(): any {
  yield all([yield takeLatest(t.GET_SESSION_TOKEN, handleSessionToken)]);
}

export default sessionSaga;
